import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { GetDataModel } from '@pos/app/scripts/services/get-data-model';
import { LocationManager } from '@shared/app/scripts/services/location-manager';
import { SaleModel } from '@shared/app/scripts/classes/sale-model';

/*
 * Component responsible for /transit-order route.
 */
angular
  .module('posApp')
  .directive(
    'transitOrder',
    (
      SaleModel,
      getDataModel: GetDataModel,
      locationManager: LocationManager,
      navigateTo: NavigateTo,
      pos,
      transitOrderInfo,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./transit-order.html').default,

      link: function ($scope: any, element, attrs) {
        $scope.pos = pos;

        $scope.warehouses = [];

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        $scope.onChangeCashier = () => {
          return;
        };

        // $ngOnInit
        $scope.warehouses = _.reject(
          locationManager.all,
          (value) => value.wh === pos.config.cashregisterNr,
        );

        //  Start transit order. Reset transaction, set mode of direction and warehouse of the transit order
        $scope.startTransit = (warehouseName, warehouseId) => {
          transitOrderInfo(
            warehouseId,
            warehouseName,
            pos.config.transitDirection,
          );

          pos.transaction = new SaleModel(getDataModel.getTransaction());
          pos.transaction.transit = {
            transitPeer: transitOrderInfo.warehouseId,
            transitWarehouse: transitOrderInfo.warehouseName,
            dir: transitOrderInfo.direction,
          };

          pos.transaction.type = 3;

          navigateTo('pos.route#checkout-transit-order');
        };
      },
    }),
  );
